import Vue from 'vue'
import VueRouter from 'vue-router'

import AppPanel from '@/views/AppPanel'
import Console from '@/views/Console'
import Dashboard from '@/views/Dashboard'
import SettingsPanel from '@/views/SettingsPanel'
import CandelaDocs from '@/views/docs/CandelaDocs'
import Doc from '@/views/docs/Doc'
import DocViewer from '@/views/docs/DocViewer'

Vue.use(VueRouter)

const Routes = {
  Apps: {name: 'apps', path: 'apps'},
  Dashboard: {name: 'dashboard', path: '/'},
  Docs: {name: 'docs', path: 'docs'},
  Logs: {name: 'logs', path: 'logs'},
  QuickStartDoc: {name: 'quickstart', path: 'docs/quickstart'},
  Settings: {name: 'settings', path: 'settings'}
}

const make_doc_route = (context, name, path) => {
  const docs = context
  const children = docs.keys().map(c => {
    const data = docs(c)
    const is_index = c === './index.yaml'
    const child_name = is_index ? `${name}-index` : data.path
    return {
      component: Doc,
      name: child_name,
      path: data.path,
      published: data.published,
      props: {data, parent: name}
    }
  }).filter(c => c && c.published)
    .sort((a, b) => a.props.data.title.localeCompare(b.props.data.title))

  return {
    path,
    name,
    children,
    props: {route_name: name},
    component: DocViewer
  }
}

const router = new VueRouter({
  routes: [{
    ...Routes.Dashboard,
    component: Dashboard,
    children: [{
      ...Routes.Apps,
      component: AppPanel
    }, {
      ...Routes.Logs,
      component: Console
    }, {
      ...Routes.Settings,
      component: SettingsPanel
    }, {
      ...Routes.Docs,
      component: CandelaDocs,
      children: [
        make_doc_route(
          require.context(
            '@/assets/docs/quickstart/', false, /.yaml$/
          ),
          'quickstart',
          'quickstart'
        ),
        make_doc_route(
          require.context(
            '@/assets/docs/guides/', false, /.yaml$/
          ),
          'guides',
          'guides'
        ),
        /*
        make_doc_route(
          require.context(
            '@/assets/docs/clients/', false, /.yaml$/
          ),
          'clients',
          'clients'
        ),
        */
        make_doc_route(
          require.context(
            '@/assets/docs/components/', false, /.yaml$/
          ),
          'components',
          'components'
        ),
        make_doc_route(
          require.context(
            '@/assets/docs/controls/', false, /.yaml$/
          ),
          'controls',
          'controls'
        ),
        make_doc_route(
          require.context(
            '@/assets/docs/glossary', false, /.yaml$/
          ),
          'glossary',
          'glossary'
        )
      ]
    }]
  }]
})

export {router, Routes}
